import { cva, type VariantProps } from "class-variance-authority";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/atoms/tooltip";
import { TagsValue } from "~/molecules/Tags";

const moreTooltipVariants = cva(
  "flex items-center justify-center text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        category:
          "h-7 w-7 rounded-2xl bg-emerald-100 hover:bg-emerald-200 text-emerald-700",
        tag: "rounded-full border border-transparent bg-tag-muted px-1.5 py-0.5 text-tag font-semibold whitespace-nowrap hover:bg-tag-muted/80",
      },
    },
    defaultVariants: {
      variant: "category",
    },
  },
);

interface Props extends VariantProps<typeof moreTooltipVariants> {
  data: string[];
}

const MoreTooltip = ({ data, variant }: Props) => {
  if (data.length <= 1) return null;

  const isTag = variant === "tag";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <span className={moreTooltipVariants({ variant })}>
            +{data.length - 1}
          </span>
        </TooltipTrigger>
        <TooltipContent className="flex flex-col gap-1.5 p-2">
          {data
            .slice(1)
            .map((item) =>
              isTag ? (
                <TagsValue key={item}>{item}</TagsValue>
              ) : (
                <p key={item}>{item}</p>
              ),
            )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default MoreTooltip;
